import { render, staticRenderFns } from "./ApiManagement.vue?vue&type=template&id=407d8d6d&scoped=true"
import script from "./ApiManagement.vue?vue&type=script&lang=js"
export * from "./ApiManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407d8d6d",
  null
  
)

export default component.exports